import type { ParametreGeneralEntite } from '@mairistem/comptabilite';
import React from 'react';

import './EntiteSection.css';

interface EntiteSectionProps {
  entite: ParametreGeneralEntite;
}

const EntiteSection = ({ entite }: EntiteSectionProps) => (
  <div className="entite-section-container">
    {entite.codeCollectivite}
    -
    {entite.codeBudget}
    {' | '}
    {entite.raisonSociale}
  </div>
);

export default EntiteSection;
